<template>
	<div class="">
		<input type="tel" class="form-control" :class="{'form-control-alt':formAlt}"
					 :id="'phone_'+id" name="phone" :value="formattedValue"
					 @blur="phoneChanged($event.target.value)" :required="isRequired"/>
		<span><small class="text-muted">(201) 555-0123 <span
				v-if="allowExtensions">ext. 14583</span></small></span>
		<span v-if="error"><small class="text-danger">{{ error }}</small></span>
	</div>
</template>


<script>

export default {
	props: {
		value: String,
		isRequired: {
			type: Boolean,
			default: false
		},
		allowExtensions: {
			type: Boolean,
			default: false,
		},
		extension: {
			type: String,
			required: false,
		},
		formAlt: {
			type: Boolean,
			default: false
		}
	},
	data() {
		return {
			formattedValue: '',
			iti: null,
			id: null,
			error: ''
		}
	},
	methods: {
		phoneChanged(phone) {
			const phoneIntlTelInput = this.iti;
			if(phoneIntlTelInput.isValidNumberPrecise()) {
				this.$emit('input', phoneIntlTelInput.getNumber());
				if(this.allowExtensions) {
					this.$emit('extension', phoneIntlTelInput.getExtension());
				}
				this.formattedValue = phoneIntlTelInput.getNumber(intlTelInput.utils.numberFormat.NATIONAL);
				this.error = '';
			} else if( this.isRequired ) {
				this.error = 'Please enter a valid phone number.';
			} else {
				this.$emit('input', phone);
			}
		}
	},
	mounted() {
		this.id = this._uid;
		this.formattedValue = this.value;

		const vm = this;
		Vue.nextTick(function() {
			let value = vm.value || '';
			if(vm.allowExtensions && vm.extension) {
				value += ' ext. ' + vm.extension;
			}
			vm.iti = window.intlTelInput(document.querySelector("#phone_" + vm.id), {
				containerClass: 'bw-phone-container',
				initialCountry: 'us',
				formatOnDisplay: true,
				allowExtensions: vm.allowExtensions,
				value: vm.value,
			});
			vm.formattedValue = vm.iti.getNumber(intlTelInput.utils.numberFormat.NATIONAL);
		});
	},
	watch: {
		value(phone) {
			if( phone ) {
				if (phone.substring(0, 1) !== '+') {
					this.formattedValue = phone;
				} else {
					this.iti.setNumber(phone + (this.allowExtensions && this.extension ? ' x '+this.extension : ''));

					this.formattedValue = this.iti.getNumber(intlTelInput.utils.numberFormat.NATIONAL);
				}
			} else {
				this.iti.setNumber('');

				this.formattedValue = '';
			}
		}
	}
};
</script>
<style>
.bw-phone-container { width: 100% }
</style>